<div fxLayout="row" fxLayoutAlign="space-between center">
    <div class="column">
      <h2 class="row">{{ "sdt-position.title" | translate }}</h2>
      <mat-paginator
      [length]="totalElements"
      [pageSizeOptions]="[5, 10, 25, 400]"
      [pageSize]="this.defaultPageSize"
      #paginator
      showFirstLastButtons
      (page)="this.handlePageEvent($event)"
    ></mat-paginator>
    </div>
    <div
      fxLayout="row"
      fxLayoutAlign="end center"
      class="searchbox"
    >
      <mat-form-field style="margin-right: 15px">
        <input
          matInput
          [placeholder]="placeholderSearch"
          #filter
        />
      </mat-form-field>
      <div *ngIf="topMenuIcons.length > 0">
        <button
          mat-raised-button
          *ngFor="let action of topMenuIcons"
          [routerLink]="action.routerLink"
          (click)="this[action.clickMethod]()"
          [disabled]="action.disabled ? action.disabled : false"
        >
          <mat-icon [title]="action.title"> {{ action.icon }} </mat-icon>
        </button>
      </div>
      <button
        mat-raised-button
        (click)="exporter.exportTable('xlsx', {fileName:exportPrefix+formatted})">
        <mat-icon
          [title]="titleExcel">download
        </mat-icon>
      </button>
    </div>
  </div>

  <div class="top-table-sticky-header">
  <mat-table
    [dataSource]="dataSource"
    [paginator]="paginator"
    [filter]="filter"
    class="mat-elevation-z8"
    matSort
    [matSortActive]="this.defaultSort.active"
    [matSortDirection]="this.defaultSort.direction"
    matSortDisableClear
    appNgMatTableQueryReflector
    matTableExporter
    #exporter="matTableExporter"
    [hiddenColumns]="[0]"
  >
    <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->
    <ng-container matColumnDef="id">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle">
        id
      </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{ element.id }} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="chainage">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
        {{ "sdt-position.chainage" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="m-card-title has_label_on_mobile" [attr.data-label]='("sdt-position.chainage" | translate) + ":"'>
        {{ element.chainage | number : '.0-3'  }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
        {{ "sdt-position.name" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="m-card-title has_label_on_mobile" [attr.data-label]='("sdt-position.name" | translate) + ":"'>
        {{ element.name   }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="actInclination">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
        {{ "sdt-position.act-inclination" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element; let i = index"
      class="m-card-title has_label_on_mobile"
      [attr.data-label]='("sdt-position.act-inclination" | translate) + ":"'>
        {{ element.actInclination | number : '.0-3'  }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="planInclination">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
        {{ "sdt-position.plan-inclination" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element; let i = index"
      class="m-card-title has_label_on_mobile"
      [attr.data-label]='("sdt-position.plan-inclination" | translate) + ":"'>
        {{ element.planInclination | number : '.0-3'  }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="prevInclination">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
        {{ "sdt-position.prev-inclination" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element; let i = index"
      class="m-card-title has_label_on_mobile"
      [attr.data-label]='("sdt-position.prev-inclination" | translate) + ":"'>
        {{ element.prevInclination | number : '.0-3'  }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="directionGermany">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
        {{ "sdt-position.direction-germany" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element; let i = index" class="m-card-title has_label_on_mobile" [attr.data-label]='("sdt-position.direction-germany"| translate) + ":"'>
        <mat-icon  *ngIf="element.directionGermany && element.directionGermany==true"> checked </mat-icon>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="diffBermHeight">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
        {{ "sdt-position.diff-berm-height" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="m-card-title has_label_on_mobile" [attr.data-label]='("sdt-position.diff-berm-height" | translate) + ":"'>
        {{ element.diffBermHeight | number : '.0-3'  }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="hightFirstBerm">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
        {{ "sdt-position.hight-first-berm" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="m-card-title has_label_on_mobile" [attr.data-label]='("sdt-position.hight-first-berm" | translate) + ":"'>
        {{ element.hightFirstBerm | number : '.0-3'  }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="nrBerms">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
        {{ "sdt-position.nr-berms" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="m-card-title has_label_on_mobile" [attr.data-label]='("sdt-position.nr-berms" | translate) + ":"'>
        {{ element.nrBerms | number : '.0-3'  }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="autoCorrection">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
        {{ "sdt-position.auto_correction" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element; let i = index" class="m-card-title has_label_on_mobile" [attr.data-label]='("sdt-position.auto_correction"| translate) + ":"'>
        <mat-icon  *ngIf="element.autoCorrection && element.autoCorrection==true"> checked </mat-icon>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="actBermSpacing">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
        {{ "sdt-position.act-berm-spacing" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="m-card-title has_label_on_mobile" [attr.data-label]='("sdt-position.act-berm-spacing" | translate) + ":"'>
        {{ element.actBermSpacing | number : '.0-3'  }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="planBermSpacing">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
        {{ "sdt-position.plan-berm-spacing" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="m-card-title has_label_on_mobile" [attr.data-label]='("sdt-position.plan-berm-spacing" | translate) + ":"'>
        {{ element.planBermSpacing | number : '.0-3'  }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="latestError">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
        {{ "sdt-position.latest-error" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="m-card-title has_label_on_mobile" [attr.data-label]='("sdt-position.latest-error" | translate) + ":"'>
        {{ element.latestError   }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="lock">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
        {{ "sdt-position.lock" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element; let i = index" class="m-card-title has_label_on_mobile" [attr.data-label]='("sdt-position.lock"| translate) + ":"'>
        <mat-icon  *ngIf="element.lock && element.lock==true"> checked </mat-icon>
      </mat-cell>
    </ng-container>

   <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle" class="one_actions"> </mat-header-cell>
      <mat-cell *matCellDef="let element" class="m-card-title one_actions">
        <div *ngIf="actions.length > 0">
          <button
            class="icon-button"
            *ngFor="let action of actions"
            [routerLink]="action.routerLink + element.id"
            (click)="this[action.clickMethod](element.id)"
            [state]="{ listdata: listIds }"

          >
            <mat-icon [title]="action.title"> {{ action.icon }} </mat-icon>
          </button>
        </div>
      </mat-cell>
    </ng-container>


    <mat-header-row *matHeaderRowDef="displayedColumns;sticky:true"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>
  </div>




